(() => {
  const host = document.querySelector('dod-welcome-gift');
  if (!host || host.dataset.initialized) return;
  host.dataset.initialized = 'true';
  const dialog = host.querySelector('dialog');
  const copy = JSON.parse(host.querySelector('[data-gift-copy]').textContent);
  const requestedPreview = new URLSearchParams(location.search).get('gift_preview') === '1';
  const designMode = host.dataset.designMode === 'true';
  const ready = host.dataset.checkoutReady === 'true' && !designMode;
  const preview = designMode || (requestedPreview && host.dataset.themeRole !== 'main');
  if (!preview && !ready) return;
  const choices = [...host.querySelectorAll('[data-gift-pick]')];
  const available = choices.filter(choice => !choice.disabled);
  const submit = host.querySelector('[data-gift-submit]');
  const selectedTitle = host.querySelector('[data-gift-selected-title]');
  const title = host.querySelector('#DodGiftTitle');
  const confirmation = host.querySelector('[data-gift-confirmation]');
  const status = host.querySelector('[data-gift-status]');
  const cartButton = host.querySelector('[data-gift-cart]');
  const closeButtons = [...host.querySelectorAll('[data-gift-close]')];
  const seenKey = 'dod-ln-gift-seen';
  const giftVariants = new Set(copy.gift_variants.map(String));
  const root = window.Shopify?.routes?.root || '/';
  let selected = '';
  let applied = '';
  let userPicked = false;
  let previousFocus;
  let busy = false;
  let syncing = false;
  let needsRefresh = false;
  let cartChanged = false;
  let latestCart;
  let drawer;
  let seen = false;
  try { seen = sessionStorage.getItem(seenKey) === '1'; } catch (_) {}
  const giftIn = cart => cart?.items?.find(item => giftVariants.has(String(item.variant_id)) && String(item.properties?._dodWelcomeGift) === '1');
  const markSeen = () => { seen = true; try { sessionStorage.setItem(seenKey,'1'); } catch (_) {} };
  const close = () => {
    if (busy) return;
    markSeen();
    dialog.close();
    if (cartChanged && /\/cart\/?$/.test(location.pathname)) location.reload();
  };
  const showSelection = value => {
    const choice = available.find(item => item.dataset.giftPick === String(value)) || available[0];
    selected = choice?.dataset.giftPick || '';
    choices.forEach(item => {
      item.checked = item.dataset.giftPick === selected;
      item.closest('[data-gift-card]').classList.toggle('is-selected',item.checked);
    });
    selectedTitle.textContent = choice?.dataset.giftTitle || copy.none_available;
    const committed = Boolean(selected && selected === applied);
    submit.disabled = busy || syncing || !selected || committed;
    submit.textContent = busy ? copy.updating : committed ? copy.selected : copy.add_selected;
    submit.classList.toggle('is-applied',committed && !busy);
    submit.setAttribute('aria-busy',String(busy));
    available.forEach(item => { item.disabled = busy; });
    closeButtons.forEach(button => { button.disabled = busy; });
    cartButton.disabled = busy || syncing;
    host.setAttribute('aria-busy',String(busy));
  };
  const show = reminder => {
    previousFocus = drawer?.activeElement || document.activeElement;
    confirmation.hidden = !reminder;
    title.textContent = reminder ? title.dataset.giftTitleReminder : title.dataset.giftTitleInitial;
    status.textContent = '';
    dialog.showModal();
  };
  const ensureRendered = async cart => {
    drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const sections = drawer.getSectionsToRender().map(section => section.id);
    if (!cart?.sections || sections.some(id => !cart.sections[id])) {
      const url = new URL(root,location.origin);
      url.searchParams.set('sections',sections.join(','));
      const response = await fetch(url,{headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(copy.unavailable);
      cart = {...cart,sections:await response.json()};
      if (sections.some(id => !cart.sections[id])) throw new Error(copy.unavailable);
    }
    drawer.classList.toggle('is-empty',cart.item_count === 0);
    drawer.renderContents(cart,false);
  };
  const openCart = async cart => {
    if (cart) await ensureRendered(cart);
    markSeen();
    dialog.close();
    drawer = document.querySelector('cart-drawer');
    if (drawer) window.setTimeout(() => drawer.open(previousFocus),0);
    else location.assign(root+'cart');
  };
  showSelection('');
  document.addEventListener('dod:gift-state',event => {
    latestCart = event.detail.cart;
    applied = String(event.detail.selected || '');
    showSelection(!userPicked || busy ? applied || selected : selected);
    if (event.detail.message) status.textContent = event.detail.message;
    else if (event.detail.reserved) status.textContent = copy.reserved;
    else if (event.detail.selected) status.textContent = copy.added;
    else status.textContent = '';
  });
  window.DODWelcomeGift = {
    openAfterAdd(cart,cartDrawer,pendingSync=false) {
      if (!ready || busy || dialog.open || !available.length || applied || giftIn(cart) || !Array.isArray(cart?.items) || !window.DODGameTiers?.count(cart)) return false;
      if (document.querySelector('dialog[open]') || cartDrawer.classList.contains('active')) return false;
      latestCart = cart;
      drawer = cartDrawer;
      syncing = pendingSync;
      needsRefresh = false;
      showSelection(selected);
      show(true);
      markSeen();
      return true;
    },
    finishSync(cart,error) {
      syncing = false;
      needsRefresh = Boolean(error);
      if (cart) latestCart = cart;
      if (error) status.textContent = copy.unavailable;
      else if (cart?.gift_notice) status.textContent = cart.gift_notice;
      showSelection(selected);
    }
  };
  closeButtons.forEach(button => button.addEventListener('click',close));
  dialog.addEventListener('click',event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('cancel',event => { if (busy) event.preventDefault(); else markSeen(); });
  dialog.addEventListener('close',() => { if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true}); });
  choices.forEach(choice => choice.addEventListener('change',() => {
    if (busy || choice.disabled) return;
    userPicked = true;
    status.textContent = '';
    showSelection(choice.dataset.giftPick);
  }));
  cartButton.addEventListener('click',async () => {
    if (busy || syncing) return;
    busy = true;
    showSelection(selected);
    try {
      if (needsRefresh || !latestCart) latestCart = await window.DODGameTiers.sync();
      await openCart(latestCart);
    } catch (_) { location.assign(root+'cart'); }
    finally { busy = false; showSelection(selected); }
  });
  submit.addEventListener('click',async () => {
    if (busy || syncing || !selected || selected === applied) return;
    const choice = available.find(item => item.dataset.giftPick === selected);
    if (!choice) return;
    if (!ready) {
      status.textContent = copy.preview_selected.replace('[game]',choice.dataset.giftTitle);
      return;
    }
    if (!window.DODGameTiers) { status.textContent = copy.unavailable; return; }
    busy = true;
    status.textContent = copy.updating;
    showSelection(selected);
    try {
      const requested = selected;
      const cart = await window.DODGameTiers.selectGift(requested);
      latestCart = cart;
      const gift = giftIn(cart);
      if (cart.gift_notice) throw new Error(cart.gift_notice);
      if (window.DODGameTiers.count(cart) && (!gift || String(gift.variant_id) !== requested || Number(gift.final_line_price) !== 0)) throw new Error(copy.unavailable);
      window.DODGameTiers.render(cart);
      cartChanged = true;
      markSeen();
      if (gift) {
        try { await openCart(cart); }
        catch (_) { location.assign(root+'cart'); }
      }
    } catch (error) { status.textContent = error.message || copy.unavailable; }
    finally { busy = false; showSelection(selected); }
  });
  host.querySelector('[data-gift-preview]').hidden = ready || !preview;
  if (preview || !seen) {
    const showWhenReady = () => {
      if (!host.isConnected || dialog.open || (!preview && (seen || applied || giftIn(latestCart))) || document.querySelector('dod-after-add dialog[open], cart-drawer.active')) return;
      if (window.DODGameTiers?.busy) { window.setTimeout(showWhenReady,250); return; }
      show(false);
    };
    window.setTimeout(showWhenReady,2000);
  }
})();
